

var _squid = require('squid');

require('xo-address-components/src/add-address/directive');

require('xo-address-components/src/address-normalization/route');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBillingRoute', function () {
    return _squid.$ComponentRoute.extend('AddBillingRoute', {
        name: 'addBilling',
        directive: 'xo-add-billing',
        titleContent: 'addBillingAddress.title',
        query: ['flow_type'],
        trackingData: {
            fptiState: 'edit_billing'
        },
        loginRequired: true,
        children: [{
            name: '$AddressNormalizationRoute',
            attributes: {
                id: 'token',
                sidebar: 'sidebar',
                address: 'address',
                'done-fn': 'uponNormalization'
            }
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addbilling/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addbilling/route.js
// module chunks = 0